import React from 'react';
import OrderSummary from '../orderSummary';
import { ShoppingCartSummaryPanelProps } from '../interfaces';

const ShoppingCartSummaryPanel: React.FC<ShoppingCartSummaryPanelProps> = ({
  animateClass,
  checkoutDisabledMessage,
  isCheckoutBlocked,
  isPricingLoading,
  totalAmount,
  onCheckout,
}) => (
  <div className={`order-summary-fixed ${animateClass}`} id="order-summary">
    <OrderSummary
      handleNavigate={onCheckout}
      totalAmount={totalAmount}
      isPricingLoading={isPricingLoading}
      isCheckoutDisabled={isCheckoutBlocked}
      checkoutDisabledMessage={checkoutDisabledMessage}
    />
  </div>
);

export default React.memo(ShoppingCartSummaryPanel);
